import { EntityDetail } from '@/common/entityFramework/entityDetail/EntityDetail';
import { AbvPriceActionPctForm } from './AbvPriceActionPctForm';

export const AbvPriceActionPctDetail = () => {

  const tabSpecs = [
    { id: 'infoTab', label: 'Info', content: <AbvPriceActionPctForm /> }
  ];

  return (
    <EntityDetail tabSpecs={tabSpecs} />
  )
}